import axiosInstance from '../auth/axiosInstance';

export const profileUpdate = async (userData) => {
  try {
    const { userId, userName, jobTitle, contact, businessType } = userData;

    const { data } = await axiosInstance.post('/User/update-user-profile', {
      userId,
      userName,
      jobTitle,
      contact,
      businessType,
    });

    console.log('profile update:', data);
    return data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    console.error('Error updating profile:', errorMessage);
    throw new Error(errorMessage);
  }
};

export const getProfileInfo = async (userId) => {
  try {
    const { data } = await axiosInstance.get(`/User/get-profile-info/${userId}`);
    return data;
  } catch (error) {
    console.error('Error fetching reports:', error);
    throw error;
  }
};

export const getProjectUserList = async (payload) => {
  try {
    if (!payload) {
      throw new Error('Project ID is required to fetch assessment details.');
    }

    const { data } = await axiosInstance.post('/project/get-project-users-list', payload);
    return data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    console.error('Error during API call:', errorMessage);
    throw new Error(errorMessage);
  }
};

export const removeUserFromProject = async (payload) => {
  try {
    if (!payload?.userId || !payload?.projectId) {
      throw new Error('User ID and Project ID are required to remove a team member.');
    }

    const { data } = await axiosInstance.post('/project/remove-user-from-project', {
      userId: payload.userId,
      projectId: payload.projectId,
    });

    if (data?.succeeded === false || data?.success === false) {
      throw new Error(data?.message || 'Failed to remove user from project.');
    }

    return data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    console.error('Error removing user from project:', errorMessage);
    throw new Error(errorMessage);
  }
};

export const getUserActivityLogs = async (payload) => {
  if (!payload) {
    throw new Error('Project ID is required to fetch activity logs');
  }
  try {
    const { data } = await axiosInstance.post('/Log/get-user-activity-logs', payload);
    return data;
  } catch (error) {
    console.error('Error fetching user activity logs:', error);
    throw error;
  }
};
